import { render, staticRenderFns } from "./Chop.vue?vue&type=template&id=318fdea5&"
import script from "./Chop.vue?vue&type=script&lang=js&"
export * from "./Chop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports